module.exports = __webpack_public_path__ + "static/media/fb1.68c9f132.png";